import { baseUrl } from '@/config'
import request from '@/axios'


export function login(data) {
  return request({
    url: baseUrl+'/login',
    method: 'post',
    params: data
  })
}

export function fetchList(query) {
  return request({
    url: baseUrl+'/system/user/listdata',
    method: 'post',
    params: query
  })
}
// 新增
export function addObj(obj) {
  return request({
    url: baseUrl+'/system/user/save',
    method: 'post',
    params: obj
  })
}
// 设置用户角色
export function setUserRole(query) {
  return request({
    url: baseUrl+'/system/user/setUserRole',
    method: 'post',
    params: query
  })
}
// 删除
export function delObj(data) {
  return request({
    url: baseUrl+'/system/user/delete',
    method: 'post',
    params:data
  })
}

export function getLoginUserInfo() {
  return request({
    url: baseUrl+'/system/user/userinfo',
    method: 'get',
  })
}

export function getUserPermissionList() {
  return request({
    url: baseUrl+'/system/menu/usermenulist',
    method: 'post',
  })
}

export function isExsit(params) {
  return request({
    url: baseUrl+'/admin/user/check/exsit',
    method: 'get',
    params: params
  })
}

// 更改个人信息
export function editInfo(obj) {
  return request({
    url: baseUrl+'/admin/user/edit',
    method: 'put',
    data: obj
  })
}

// 设置手机号的验证规则
export const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入手机号'))
  } else {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
    if (!reg.test(value)) {
      return callback(new Error('请输入正确的电话'))
    }
  }
}


// 模板列表
export function tplist(obj) {
  return request({
    url: baseUrl+'/webide/screen/visual/tplList',
    method: 'post',
    params: obj
  })
}